import { ref, onBeforeUnmount } from 'vue';

export function usePreventTextSelection() {
  const isPreventingSelection = ref(false);

  const clearSelection = () => {
    if (window.getSelection) {
      const selection = window.getSelection();
      if (selection?.empty) {  // Chrome
        selection.empty();
      } else if (selection?.removeAllRanges) {  // Firefox
        selection.removeAllRanges();
      }
    }
  };

  const startPreventingSelection = () => {
    if (!isPreventingSelection.value) {
      isPreventingSelection.value = true;
      document.body.classList.add('preventing-text-selection');
      clearSelection();
    }
  };


  const stopPreventingSelection = (delay = 0) => {
    if (delay > 0) {
      setTimeout(() => {
        document.body.classList.remove('preventing-text-selection');
        isPreventingSelection.value = false;
      }, delay);
    } else {
      document.body.classList.remove('preventing-text-selection');
      isPreventingSelection.value = false;
    }
  };

  const handleMouseMove = () => {
    if (isPreventingSelection.value) {
      clearSelection();
    }
  };

  window.addEventListener('mousemove', handleMouseMove);

  onBeforeUnmount(() => {
    window.removeEventListener('mousemove', handleMouseMove);
    stopPreventingSelection();
  });

  return {
    isPreventingSelection,
    startPreventingSelection,
    stopPreventingSelection,
    clearSelection
  };
}
